import { NAV_LINKS } from '../data/site';
import SectionLink from './SectionLink';
import ResumeLink from './ResumeLink';

export default function Nav({ scrolled, activeId, menuOpen, onMenuOpen }) {
  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 border-b ${
        scrolled
          ? 'bg-void/75 backdrop-blur-md border-line'
          : 'bg-transparent border-transparent'
      }`}
    >
      <div className="max-w-page mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <SectionLink
          href="#home"
          className="group flex items-center gap-2.5 text-sm font-medium text-ink"
          aria-label="Home"
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inset-0 rounded-full bg-accent animate-pulse-dot" />
            <span className="relative h-2 w-2 rounded-full bg-accent" />
          </span>
          <span className="font-mono text-xs tracking-wide">janmesh.joshi</span>
        </SectionLink>

        <nav className="hidden md:flex items-center gap-1" aria-label="Main navigation">
          {NAV_LINKS.map((l) => (
            <SectionLink
              key={l.href}
              href={l.href}
              className={`relative px-3 py-1.5 text-sm rounded-full transition-colors ${
                activeId === l.id ? 'text-ink bg-white/[0.06]' : 'text-muted hover:text-ink'
              }`}
              aria-current={activeId === l.id ? 'true' : undefined}
            >
              {l.label}
            </SectionLink>
          ))}
          <ResumeLink className="ml-3 btn-ghost !h-9 !px-4 text-xs">Resume</ResumeLink>
        </nav>

        <button
          type="button"
          onClick={onMenuOpen}
          className="md:hidden inline-flex items-center gap-2 h-9 pl-3.5 pr-3 rounded-full border border-line-2 bg-void/60 text-xs font-medium text-ink"
          aria-label="Open menu"
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
        >
          Menu
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
            <line x1="4" y1="8" x2="20" y2="8" /><line x1="4" y1="16" x2="20" y2="16" />
          </svg>
        </button>
      </div>
    </header>
  );
}
